import React, { Component } from 'react'
import Button from '../../UI/Button/Button'
import { InputTextVal } from '../../UI/Input/Input'
import { ONBOARDING_API } from '../../../constants/ApiConstants'
import axios from 'axios'

export default class ClientInfo extends Component {
    constructor() {
        super()

        this.state = {
            email: '',
            emailError: '',
            tradingName: '',
            contactName: '',
            phone: '',
            phoneError: '',
            cnpj: '',
            cnpjError: ''
        }
    }

    handleChange = event => {
        const isCheckbox = event.target.type === 'checkbox'

        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        })
    }

    setError = (type, valid) => {
        console.log(type, valid)
        this.setState({
            [type]: valid
        })
    }

    sendClienteInfo = event => {
        event.preventDefault()

        const interest = sessionStorage.getItem('primaryinterest');

        const req = {
            cnpj: this.state.cnpj,
            trade: this.state.tradingName,
            email: this.state.email,
            contactName: this.state.contactName,
            contactMobileNumber: this.state.phone,
            deviceInfo: window.navigator.appVersion,
            primaryinterest: interest || ''
        }

        axios.post(`${ONBOARDING_API}`, req).then(resp => {
            sessionStorage.setItem('companyId', resp.data.companyId)
            sessionStorage.setItem('companyEmail', req.email)

            this.props.sendInfo(this, 1)
        }).catch(error => {
            let errorList = {
                cnpjError: '',
                emailError: '',
                phoneError: ''
            }

            for (let i in error.response.data.validations) {
                const item = error.response.data.validations[i]

                switch (item.field) {
                    case 'cnpj':
                        errorList.cnpjError = item.message
                        break;
                    case 'email':
                        errorList.emailError = item.message
                        break;
                    case 'contactmobilenumber':
                        errorList.phoneError = item.message
                        break;
                    default:
                        break;
                }
            }

            this.setState({
                cnpjError: errorList.cnpjError,
                emailError: errorList.emailError,
                phoneError: errorList.phoneError
            })
        })
    }

    render() {
        return(
           <form name="clientInfo" autoComplete="none">
                <div className="row">
                    <InputTextVal
                        type="email"
                        autoComplete={'off'}
                        name="email"
                        onChange={this.handleChange}
                        value={this.state.email}
                        error={this.state.emailError}
                        setError={this.setError.bind(this, 'emailError')}
                        text="E-mail"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        autoComplete={'off'}
                        name="tradingName"
                        onChange={this.handleChange}
                        value={this.state.tradingName}
                        text="Nome fantasia"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        autoComplete={'off'}
                        name="contactName"
                        onChange={this.handleChange}
                        value={this.state.contactName}
                        text="Nome do contato"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal type="number"
                        text="Celular"
                        autoComplete="off"
                        mask="phone"
                        name="phone"
                        max="99999999999"
                        maxLength={10}
                        onChange={this.handleChange}
                        value={this.state.phone}
                        error={this.state.phoneError}
                        setError={this.setError.bind(this, 'phoneError')}
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal type="number"
                        text="CNPJ"
                        autoComplete="off"
                        mask="cnpj"
                        name="cnpj"
                        max="99999999999999"
                        maxLength={13}
                        onChange={this.handleChange}
                        value={this.state.cnpj}
                        error={this.state.cnpjError}
                        setError={this.setError.bind(this, 'cnpjError')}
                    ></InputTextVal>
                </div>
                <div className="options">
                    <Button
                        onClick={this.sendClienteInfo.bind(this)}
                        disabled={
                            !this.state.email ||
                            this.state.emailError ||
                            !this.state.tradingName ||
                            !this.state.contactName ||
                            !this.state.phone ||
                            this.state.phoneError ||
                            !this.state.cnpj ||
                            this.state.cnpjError
                        }
                        text="Avançar"
                    ></Button>
                </div>
            </form>
        )
    }
}